<div >
  <div class="content vin">
    <ul ngbNav class="nav-tabs mt-2" #nav="ngbNav" style="min-height: unset">
      <ng-container *ngFor="let tab of tabs; let i = index">
        <li  ngbNavItem="{{i}}">
          <a ngbNavLink>{{tab.title}}</a>
          <ng-template ngbNavContent>
            <ng-container *ngComponentOutlet="tab.component"></ng-container>
          </ng-template>
        </li>
      </ng-container>
    </ul>
    <div [ngbNavOutlet]="nav" class="mt-3"></div>
    <router-outlet></router-outlet>
  </div>
</div>
